import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactModal from 'react-modal';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class TimerUpModal extends Component {
    render() {
        return ( 
            <div>
                <ReactModal 
                    className="showtix-event__modal"
                    isOpen={this.props.isTimerUpOpen}
                    role={
                        "dialog"
                    }
                >
                    <button className="showtix-modal__close" onClick={this.props.toggleTimerUp} aria-label="Close the modal">&times;</button>
                    <h4 className="modal-title text-center">
                        {strings.title}
                    </h4>
                    {ReactHtmlParser(strings.description)}
                    <div className="d-flex justify-content-center">
                        <button 
                            className="showtix-button showtix-background__primary-1"
                            onClick={this.props.toggleTimerUp}
                            >{strings.close}</button>  
                    </div>
                </ReactModal>
            </div>
        )
    }
}

export default TimerUpModal;


// WEBPACK FOOTER //
// ./src/components/EventListing/TimerUpModal/TimerUpModal.js